export const variableConfig = {
  testLoginPath: "http://api.insafety.online:28883/#/login",
  preLoginPath: "http://api.insafety.online:28883/#/login",
  proLoginPath: "http://api.insafety.online:28883/#/login",
};
